import React from "react";
import { useNavigate } from "react-router-dom";

const MainSettings: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-12">Admin Settings</h1>

      <section className="mb-12">
        <h2 className="text-xl font-medium mb-3">Account Preferences</h2>
        <div className="border-t border-[#EA33C0]">
          <button
            onClick={() => navigate("/account/company-details")}
            className="w-full text-left py-4 border-b border-gray-200"
          >
            <span className="text-base">Company Details</span>
          </button>
          <button
            onClick={() => navigate("/account/sign-in-security")}
            className="w-full text-left py-4 border-b border-gray-200"
          >
            <span className="text-base">Sign In Security</span>
          </button>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-medium mb-3">Billing Information</h2>
        <div className="border-t border-[#EA33C0]">
          <button className="w-full text-left py-4 border-b border-gray-200">
            <span className="text-base">Manage Subscription</span>
          </button>
          <button className="w-full text-left py-4 border-b border-gray-200">
            <span className="text-base">Statement History</span>
          </button>
        </div>
      </section>

      <div className="mt-20">
        <button className="text-gray-500 underline hover:text-gray-700">
          Close my Account
        </button>
      </div>
    </div>
  );
};

export default MainSettings;
